import { View } from 'react-native';
import { Icon } from '@/components/Icon';
import { Bar } from 'react-native-progress';
import colors from '@/config/colors';
import { allowNativeDriver } from '@/utils/allowNativeDriver';

type Props = {
  progress: number;
  withStar: boolean;
};

export const StarProgress = ({ progress, withStar }: Props) => {
  return (
    <View className="w-1/2 p-2 flex-row justify-center items-center gap-x-2">
      <Bar
        color={colors.primary}
        borderRadius={8}
        borderWidth={0}
        //https://github.com/facebook/react-native/issues/47635
        progress={progress}
        className="flex-1 w-full bg-green-neolexon/30 border-none"
        width={null}
        height={24}
        useNativeDriver={allowNativeDriver()}
      />
      {withStar ? (
        <Icon name="star" size={40} color={colors.gold} solid />
      ) : null}
    </View>
  );
};
